import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { admin, adminRoute, canRoute, candidate, empRoute, employer } from "../../../globals/route-names";
import { useAuth } from "../../../context/AuthContext";

function SignInPopup() {
    const navigate = useNavigate();
    const { login } = useAuth();
    const [form, setForm] = useState({
        email: "",
        password: ""
    });
    const [status, setStatus] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const update = (event) => {
        setForm({ ...form, [event.target.name]: event.target.value });
    };

    const destinationFor = (user) => {
        if (user.role === "admin") return adminRoute(admin.DASHBOARD);
        if (user.role === "employer") return empRoute(employer.DASHBOARD);
        return canRoute(candidate.DASHBOARD);
    };

    const closePopup = () => {
        const element = document.getElementById("sign_up_popup2");
        const modal = window.bootstrap?.Modal?.getInstance(element);
        modal?.hide();
    };

    const handleLogin = async (event) => {
        event.preventDefault();
        setStatus("");
        setSubmitting(true);
        try {
            const user = await login({ email: form.email, password: form.password });
            closePopup();
            navigate(destinationFor(user));
        } catch (error) {
            setStatus(error.message);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <>
            <div className="modal fade twm-sign-up" id="sign_up_popup2" aria-hidden="true" aria-labelledby="sign_up_popupLabel2" tabIndex={-1}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h2 className="modal-title" id="sign_up_popupLabel2">Login</h2>
                            <p>Login and get access to all the features of Jobzilla</p>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <div className="twm-tabs-style-2">
                                <ul className="nav nav-tabs" role="tablist">
                                    <li className="nav-item">
                                        <button className="nav-link active" type="button"><i className="fas fa-right-to-bracket" />Account Login</button>
                                    </li>
                                </ul>
                                <form onSubmit={handleLogin} className="p-t30">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="form-group mb-3">
                                                <input name="email" type="email" required className="form-control" placeholder="Email address*" value={form.email} onChange={update} />
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <div className="form-group mb-3">
                                                <input name="password" type="password" className="form-control" required minLength={6} placeholder="Password*" value={form.password} onChange={update} />
                                            </div>
                                        </div>
                                        {status && <div className="col-lg-12"><div className="alert alert-danger">{status}</div></div>}
                                        <div className="col-md-12">
                                            <button type="submit" className="site-button" disabled={submitting}>{submitting ? "Logging in..." : "Log in"}</button>
                                            <div className="mt-3 mb-3">Don't have an account?
                                                <button type="button" className="twm-backto-login" data-bs-target="#sign_up_popup" data-bs-toggle="modal" data-bs-dismiss="modal">Sign Up</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <span className="modal-f-title">Demo accounts</span>
                            <div>candidate@zozojobs.com / 123456</div>
                            <div>employer@zozojobs.com / 123456</div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SignInPopup;
